import { EditorView } from 'prosemirror-view';

export type MarkType = {
  name: MarkTypesEnum;
  title?: string;
  icon?: any;
  break?: string;
  list?: boolean;
  CustomComponent?: React.FC<{ editorView: EditorView }>;
};

export interface SelectionMenuProps {
  open: boolean;
  editorView: EditorView;
  link?: string;
  customMarkItems?: MarkType[];
  isLocalizedContent?: boolean;
}

export enum MarkTypesEnum {
  Bold = 'strong',
  Italic = 'em',
  Underline = 'underline',
  Strikethrough = 'strikethrough',
  Link = 'link',
  Color = 'color',
  Break = 'break',
  NumberedList = 'ordered_list',
  BulletList = 'bullet_list',
  Code = 'code_inline',
  Custom = 'custom',
  Blockquote = 'blockquote',
}

export type MarkChangeActions = {
  type: MarkTypesEnum;
  payload?: {
    color?: string;
    backgroundColor?: string;
    list?: boolean;
  };
};
